import React, { Component } from "react";
import { Translate } from "react-redux-i18n";
import Breadcrumb from "../../components/Breadcrumb";
import PendingRequests from "../../components/PendingRequests";
import CirclePuzzleGift from "../../components/CirclePuzzleGift";
import CirclePrintGiftCard from "../../components/CirclePrintGiftCard";
import CircleMembers from "../../components/CircleMembers";
import ProductInfoCard from "../../components/ProductInfoCard";
import LoadingIndicator from "../../components/LoadingIndicator";
import { navigate } from "../../store/navigation/operations";
import { connect } from "react-redux";
import { fetchCircle, purchaseItem, sendPuzzleRequest, saveCircle } from "../../store/my_circles/operations";
import { fetchCommitment } from "../../store/commitment/operations";
import { fetchMemberRequests, updateMemberRequest } from "../../store/member_requests/operations";
import { getMemberRequests, updatingRequests } from "../../store/member_requests/selectors";
import { userHasCommitment, isAgreementLoading } from "../../store/commitment/selectors";
import {
  getCircleWithId,
  loadingInitialCirclesList,
  isFetchingCircles,
  isWhiteMondayCircle,
  sendingPuzzleOrder,
  isAdmin,
  isPrylpoolenCircle
} from "../../store/my_circles/selectors";
import { loggedInUserGuid, isLoggedIn } from "../../store/iam/selectors";
import { getUserWithId, isSuperUser } from "../../store/users/selectors";
import CircleTabs from "../CircleTabs";
import StickyBox from "react-sticky-box";
import { pushNotification } from "../../store/ui_notifications/creators";
import MigrateCircleMembers from "../../components/CircleMember/MigrateCircleMembers";

class CircleAdministration extends Component {
  intervalId = undefined;

  state = {
    show_modal: false
  };

  showModal = () => {
    this.setState({ show_modal: true });
  };

  hideModal = () => {
    this.setState({ show_modal: false });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.isLoggedIn !== prevProps.isLoggedIn) {
      this.initPage();
    }
  }

  componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  componentDidMount() {
    if (this.props.isLoggedIn) {
      this.initPage();
      if (!this.intervalId) {
        this.intervalId = setInterval(this.initPage, 30000);
      }
    }
  }

  initPage = () => {
    this.props.fetchCircle(this.props.circleId, true);
    this.props.fetchMemberRequests(this.props.circleId, 'pending');
    this.props.fetchCommitment(this.props.circleId);
  };

  editCircle = () => {
    this.props.navigate(`/circle-toolbox/${this.props.circleId}/edit`);
  };

  joinRequestAction = (action, requestId) => {
    if (action === "accept") {
      this.props.updateMemberRequest(true, this.props.circleId, requestId).then(() => {
        this.props.fetchCircle(this.props.circleId, true); // update circle details, circle status may change after accepting members
      });
    } else {
      this.props.updateMemberRequest(false, this.props.circleId, requestId);
    }
  };

  purchaseItem = () => {
    this.props.purchaseItem(this.props.circleId).then(() => {
      this.props.fetchCircle(this.props.circleId, true);
    });
  };

  onMemberMessageClick = member_guid => {
    this.props.navigate(`/messages/new/${member_guid}`);
  };

  linkCopiedToClipboard = () => {};

  sendPuzzleOrder = order => {
    const payload = {
      circle_guid: this.props.circle.guid,
      email: this.props.logged_user_details.email,
      user_guid: this.props.logged_user_details.guid,
      full_name: order.name,
      address: order.address
    };
    this.props.sendPuzzleRequest(payload);
  };

  toogleCircleVisibility = () => {
    if (this.props.circle.status === "hidden") {
      this.props.saveCircle({status: "member_gathering"}, this.props.circle.guid).then(()=>{
        window.location.reload()
      });
    }else{
      this.props.saveCircle({status: "hidden"}, this.props.circle.guid).then(()=>{
        window.location.reload()
      });
    }
  }

  render() {
    const breadcrumbItems = this.props.circle
      ? [
          {
            onClick: () => {
              this.props.navigate("/dashboard");
            },
            icon: "document",
            text: <Translate value="menu.dashboard" />
          },
          { icon: "document", text: this.props.circle.products[0].name }
        ]
      : [];

    const visibilityToggleBoxStyles = {
      "padding": "10px",
        "border": "1px solid #ccc",
        "border-radius": "5px",
        "margin-top": "10px"

    }
    const hideToggleButtonStyles = {
      "cursor": "pointer",
      "text-decoration": "underline",
      "color":"red",
      "font-weight": "bold"
    }
    const showToggleButtonStyles = {...hideToggleButtonStyles, "color":"green"}

    return (
      <>
        {this.props.loadingCircle && <LoadingIndicator />}
        {!this.props.loadingCircle && this.props.circle && (
          <>
            <Breadcrumb breadcrumbItems={breadcrumbItems} extraStyle="darker zero-flex" />
            <section className="gray-bg">
              <div className="main-container">
                <div className={`content-wrapper has-sidebar circle-admin ${(this.props.is_prylpoolen && !this.props.is_super_user)?'prylpool-circle':''}`} >
                  <div className="wide-content">
                    <ProductInfoCard
                      sendingPuzzleOrder={this.props.sending_puzzle_order}
                      sendPuzzleOrder={this.sendPuzzleOrder}
                      isWhiteMonday={this.props.is_whitemonday}
                      isAdmin={this.props.is_admin}
                      is_prylpoolen={this.props.is_prylpoolen}
                      circle={this.props.circle}
                      editCircle={this.editCircle}
                      userHasSigned={this.props.has_commitment}
                      myGuid={this.props.myGuid}
                      purchaseItem={this.purchaseItem}
                      purchase_loader={this.props.updating_circle}
                      copiedToClipboard={this.props.linkCopiedToClipboard}
                    />
                    <CircleTabs circleId={this.props.circleId} />
                  </div>
                  <div className="sidebar-content">
                    <StickyBox offsetTop={80} offsetBottom={80}>
                      {this.props.is_whitemonday && this.props.is_admin && (
                        <CirclePuzzleGift
                          circle={this.props.circle}
                          sendOrder={this.sendPuzzleOrder}
                          loading={this.props.sending_puzzle_order}
                        />
                      )}
                      {this.props.is_whitemonday && this.props.is_admin && (
                        <CirclePrintGiftCard circle={this.props.circle} />
                      )}
                      {this.props.member_requests &&
                        ["member_gathering", "pending"].includes(this.props.circle.status) && (
                          <PendingRequests
                            member_requests={this.props.member_requests}
                            request_updates={this.props.request_updates}
                            takeAction={this.joinRequestAction}
                            onMessageClick={this.onMemberMessageClick}
                          />
                        )}
                      {
                        (!this.props.is_prylpoolen || this.props.is_super_user) && 
                        <>
                          {this.props.is_super_user &&
                          <>
                            {this.props.circle.status ==="hidden" &&
                                <div style={visibilityToggleBoxStyles}>Circle is hidden.
                                <span style={showToggleButtonStyles} onClick={this.toogleCircleVisibility}>Show circle</span>
                                </div>
                            }
                            {this.props.circle.status !=="hidden" &&
                                <div style={visibilityToggleBoxStyles}>Circle is visible.
                                <span style={hideToggleButtonStyles} onClick={this.toogleCircleVisibility}>Hide circle</span>
                                </div>
                            }
                          </>
                          }
                        {this.props.is_super_user && this.props.is_prylpoolen && <MigrateCircleMembers circle={this.props.circle} />}
                        {this.props.is_super_user && this.props.is_prylpoolen &&
                            <CircleMembers circle={this.props.circle}
                              locale={this.props.locale}
                              onMessageClick={this.onMemberMessageClick}
                              myGuid={this.props.myGuid}
                              isSuperUser={this.props.is_super_user}
                        />}


                        </>
                      }
                    </StickyBox>
                  </div>
                </div>
              </div>
            </section>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    isLoggedIn: isLoggedIn(state),
    locale: state.i18n.locale,
    updating_circle: isFetchingCircles(state),
    myGuid: loggedInUserGuid(state),
    logged_user_details: getUserWithId(state, loggedInUserGuid(state)),
    loadingCircle: loadingInitialCirclesList(state),
    circle: getCircleWithId(state, props.circleId),
    is_prylpoolen: isPrylpoolenCircle(state, props.circleId),
    is_super_user: isSuperUser(state, loggedInUserGuid(state)),
    is_whitemonday: isWhiteMondayCircle(state, props.circleId),
    request_updates: updatingRequests(state),
    member_requests: getMemberRequests(state, props.circleId),
    has_commitment: userHasCommitment(state, props.circleId, loggedInUserGuid(state)),
    agreement_loading: isAgreementLoading(state),
    sending_puzzle_order: sendingPuzzleOrder(state),
    is_admin: isAdmin(getCircleWithId(state, props.circleId), loggedInUserGuid(state)),
    isSuperUser: isSuperUser(state, loggedInUserGuid(state))
  };
};

const mapDispatchToProps = {
  fetchCircle,
  purchaseItem,
  fetchCommitment,
  navigate,
  fetchMemberRequests,
  updateMemberRequest,
  pushNotification,
  sendPuzzleRequest,
  saveCircle
};

export default connect(mapStateToProps, mapDispatchToProps)(CircleAdministration);
